export enum PartnerMapOperator {
    ALL = 'ALL',
    ALL_DISTRIBUTION = 'ALL DISTRIBUTION',
    ALL_PAYMENT = 'ALL PAYMENT',
    INTERSECT = 'INTERSECT',
    MINUS = 'MINUS',
    ONLY = 'ONLY',
}
